module.exports = __webpack_public_path__ + "img/Login2.d7df79e2.png";